import { Modal, notification, Select, Spin } from "antd";
import React from "react";
import { toast } from "react-toastify";
import apiClient from "../../../api/axiosConfig.tsx";
import { LoadingOutlined } from "@ant-design/icons";
import { FaPlus, FaMinus } from "react-icons/fa";

interface IndexRange {
  start: string;
  end: string;
}

const getMainContentWrapPaddingStyles = (): React.CSSProperties | undefined => {
  const root = document.querySelector("div.flex.h-screen");
  if (!root) return undefined;
  let main: HTMLElement | null = null;
  for (let i = 0; i < root.children.length; i++) {
    const el = root.children[i];
    if (
      el instanceof HTMLElement &&
      el.classList.contains("w-full") &&
      el.classList.contains("bg-white")
    ) {
      main = el;
      break;
    }
  }
  if (!main) return undefined;
  const r = main.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  return {
    paddingLeft: r.left,
    paddingRight: Math.max(0, vw - r.right),
    paddingTop: r.top,
    paddingBottom: Math.max(0, vh - r.bottom),
  };
};

const UpdateStatusFrame = () => {
  const [indexRanges, setIndexRanges] = React.useState<IndexRange[]>([
    { start: "", end: "" }
  ]);
  const [active, setActive] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  const [api, contextHolder] = notification.useNotification();

  // Generate array of numbers from start to end
  const generateIndexArray = (start: number, end: number): number[] => {
    const array: number[] = [];
    for (let i = start; i <= end; i++) {
      array.push(i);
    }
    return array;
  };

  // Add new index range
  const addIndexRange = () => {
    setIndexRanges([...indexRanges, { start: "", end: "" }]);
  };

  // Remove index range
  const removeIndexRange = (index: number) => {
    if (indexRanges.length > 1) {
      const newRanges = indexRanges.filter((_, i) => i !== index);
      setIndexRanges(newRanges);
    }
  };

  // Update specific index range
  const updateIndexRange = (index: number, field: 'start' | 'end', value: string) => {
    const newRanges = [...indexRanges];
    newRanges[index][field] = value;
    setIndexRanges(newRanges);
  };

  const validateRanges = (): string | null => {
    for (let i = 0; i < indexRanges.length; i++) {
      const range = indexRanges[i];
      if (!range.start || !range.end) {
        return `Vui lòng nhập đầy đủ index bắt đầu và kết thúc ở hàng ${i + 1}`;
      }
      const start = parseInt(range.start, 10);
      const end = parseInt(range.end, 10);
      if (Number.isNaN(start) || Number.isNaN(end)) {
        return `Index không hợp lệ ở hàng ${i + 1}`;
      }
      if (start > end) {
        return `Index bắt đầu phải nhỏ hơn hoặc bằng index kết thúc ở hàng ${i + 1}`;
      }
    }
    return null;
  };

  const rangesDescription = (): string =>
    indexRanges.map((r) => `từ ${r.start} đến ${r.end}`).join(" và ");

  const preventNumberInputStep = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  const preventNumberInputWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  };

  const openConfirmUpdate = () => {
    const err = validateRanges();
    if (err) {
      toast.error(err);
      return;
    }
    const rangeText = rangesDescription();
    const statusText = active ? "Kích hoạt" : "Không kích hoạt";
    const wrapStyles = getMainContentWrapPaddingStyles();
    Modal.confirm({
      title: "Xác nhận cập nhật frame",
      content: (
        <div className="space-y-2 text-left">
          <p>
            Bạn có chắc muốn cập nhật frame <strong>{rangeText}</strong>?
          </p>
          <p>
            <span className="font-semibold">Trạng thái:</span> {statusText}
          </p>
        </div>
      ),
      okText: "Cập nhật",
      cancelText: "Hủy",
      centered: true,
      okButtonProps: {
        className:
          "!bg-[pink] !text-white !border-[pink] hover:!text-white hover:!bg-pink-600 hover:!border-pink-600",
      },
      ...(wrapStyles ? { styles: { wrapper: wrapStyles } } : {}),
      onOk: () => handleCreateAccount(),
    });
  };

  const handleCreateAccount = async () => {
    const validationError = validateRanges();
    if (validationError) {
      toast.error(validationError);
      return;
    }

    // Generate combined index array
    let allIndexes: number[] = [];
    for (const range of indexRanges) {
      const start = parseInt(range.start, 10);
      const end = parseInt(range.end, 10);
      const rangeIndexes = generateIndexArray(start, end);
      allIndexes = [...allIndexes, ...rangeIndexes];
    }

    // Remove duplicates and sort
    allIndexes = [...new Set(allIndexes)].sort((a, b) => a - b);

    const data = {
      listIndex: allIndexes,
      data: {
        active: active,
      },
    };

    setLoading(true);
    try {
      const res = await apiClient.post(`frame/update-frame`, data);
      console.log("res ===== ", res?.data?.data?.errors);
      const failString = res?.data?.data?.errors
        ?.map((item: any) => item)
        .join(", ");
      const successString = res?.data?.data?.success
        ?.map((item: any) => item)
        .join(", ");
      console.log(
        `Cập nhật có ${res?.data?.data?.errors?.length} lỗi là index: ${failString} và có ${res?.data?.data?.success?.length} thành công`
      );
      if (res?.data?.status) {
        api.open({
          message: "Cập nhật trang thái frame thành công",
          // description: `Cập nhật có ${res?.data?.data?.errors?.length} lỗi là index: ${failString} và có ${res?.data?.data?.success?.length} thành công`,
          duration: 0,
        });
        setIndexRanges([{ start: "", end: "" }]);
      } else {
        toast.error("Cập nhật trạng thái frame thất bại");
      }
      console.log(res);
    } finally {
      setLoading(false);
    }
  };
  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";
  const classLable = "font-semibold text-[pink]";

  return (
    <div className="w-full flex flex-col items-center">
      {contextHolder}
      <div className="text-2xl text-center text-[pink] font-bold mb-6">
        CẬP NHẬT TRẠNG THÁI FRAME
      </div>
      <div className="mb-3 w-1/2">
        <div className={classLable}>
          Danh sách index Frame
        </div>
        {indexRanges.map((range, index) => (
          <div key={index} className="flex gap-4 items-end mb-2">
            <div className="flex-1">
              <input
                type="number"
                placeholder="Bắt đầu từ"
                value={range.start}
                onChange={(e) => updateIndexRange(index, 'start', e.target.value)}
                onKeyDown={preventNumberInputStep}
                onWheel={preventNumberInputWheel}
                className={classInput}
              />
            </div>
            <div className="flex-1">
              <input
                type="number"
                placeholder="Kết thúc"
                value={range.end}
                onChange={(e) => updateIndexRange(index, 'end', e.target.value)}
                onKeyDown={preventNumberInputStep}
                onWheel={preventNumberInputWheel}
                className={classInput}
              />
            </div>
            <div className="flex items-center gap-2">
              <FaPlus 
                className="text-[pink] text-3xl cursor-pointer hover:text-pink-600" 
                onClick={addIndexRange}
              />
              {indexRanges.length > 1 && (
                <FaMinus 
                  className="text-red-500 text-3xl cursor-pointer hover:text-red-600" 
                  onClick={() => removeIndexRange(index)}
                />
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mb-3 w-1/2">
        <div className={classLable}>Trạng thái kích hoạt frame</div>
        <Select
          onChange={(e) => {
            setActive(e);
          }}
          size="large"
          className="custom-select w-full text-[pink] border-[pink] rounded-md"
        >
          <Select.Option key={"active"} value={true}>
            Kích hoạt
          </Select.Option>
          <Select.Option key={"non-active"} value={false}>
            Không kích hoạt
          </Select.Option>
        </Select>
      </div>
      <div className="flex justify-center">
        <button
          className="mb-4 bg-[pink] text-white py-3 px-6 rounded-md"
          type="button"
          onClick={() => {
            openConfirmUpdate();
          }}
        >
          {loading ? (
            <Spin
              className="text-white"
              indicator={<LoadingOutlined color="white" spin />}
              size="small"
            />
          ) : (
            "Cập nhật frame"
          )}
        </button>
      </div>
    </div>
  );
};

export default UpdateStatusFrame;
